import { Song } from '../types';

export const handleImageUpload = (
  file: File,
  callback: (dataUrl: string) => void
): void => {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result as string);
  };
  reader.readAsDataURL(file);
};

export const handleAudioUpload = (
  file: File,
  callback: (url: string) => void
): void => {
  const url = URL.createObjectURL(file);
  callback(url);
};

export const validateAudioFile = (file: File): boolean => {
  const validTypes = ['audio/mpeg', 'audio/wav', 'audio/ogg', 'audio/mp3'];
  return validTypes.includes(file.type);
};

export const validateImageFile = (file: File): boolean => {
  const validTypes = ['image/jpeg', 'image/png', 'image/webp'];
  return validTypes.includes(file.type) && file.size < 5000000; // 5MB max
};

export const exportPlaylist = (playlist: Song[]): void => {
  const dataStr = JSON.stringify(playlist, null, 2);
  const dataBlob = new Blob([dataStr], { type: 'application/json' });
  const url = URL.createObjectURL(dataBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `hitster-playlist-${Date.now()}.json`;
  link.click();
  URL.revokeObjectURL(url);
};

export const importPlaylist = (file: File, callback: (playlist: Song[]) => void): void => {
  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const playlist = JSON.parse(e.target?.result as string);
      callback(playlist);
    } catch (error) {
      console.error('Invalid playlist file');
    }
  };
  reader.readAsText(file);
};
